import type { FC } from 'react'
import { SelectableListMenu } from '@platform/ui'
import { ACTIVITY_ICON_MAP, type ActivityType } from '@/api/models/activity'

import styles from './ActivityIcon.module.scss'

type ActivityIconProps = {
  type: ActivityType
}

export const ActivityIcon: FC<ActivityIconProps> = ({ type }) => {
  const icon = ACTIVITY_ICON_MAP[type]

  if (icon) {
    return <SelectableListMenu.CustomIcon wrapperSize={16} wrapperProps={{ icon }} className={styles.iconWrapper} />
  }

  return null
}
